import { render, staticRenderFns } from "./WeightInputGroup.vue?vue&type=template&id=030a87de&"
import script from "./WeightInputGroup.vue?vue&type=script&lang=ts&"
export * from "./WeightInputGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports